module.exports = __webpack_public_path__ + "img/gwnu_gallery5.bd144e92.jpg";